export default __webpack_public_path__ + "static/shape_oval_male-a09ebc9cbfa137c4e57f64a634491f5d.png";